// extracted by mini-css-extract-plugin
module.exports = {"divider":"ReadingLogs_divider__3OE5g","title":"ReadingLogs_title__1myQb","spacer":"ReadingLogs_spacer__3h6ny","rightBtnCol":"ReadingLogs_rightBtnCol__241dM"};